import React from 'react'
import { useSelector } from 'react-redux'

import ParticipantsList from 'components/Artefacts/Participants'
import Text from 'components/common/Text'
import { Modal } from 'components/Modal'
import { _studentsCount, _hasRemoteParticipants } from 'store/selectors/Room'

import { Tab } from '../styles'

const imgProps = {
    alt: 'participants-icon',
    src: '/assets/revamp/participants.svg',
    height: '80%',
    width: '80%',
}

const styles = {
    modal: {
        overflow: 'hidden',
        padding: 0,
        width: '80vw',
        height: '80vh',
        maxWidth: 'unset',
        maxHeight: 'unset',
    },
    closeButton: {
        filter: 'brightness(0) invert(1)',
    },
}

const Participants = ({ isActive, toggle }) => {
    const studentsCount = useSelector(_studentsCount) // local student + remote students
    const hasRemoteParticipants = useSelector(_hasRemoteParticipants)

    const title =
        studentsCount > 1
            ? `${studentsCount} students`
            : `${studentsCount} student`

    /* show only when there is atleast 1 remote user */
    if (studentsCount && hasRemoteParticipants)
        return (
            <>
                <Tab.Area
                    className="hover-here"
                    onClick={toggle}
                    isActive={isActive}
                >
                    <Tab.Icon>
                        <img {...imgProps} />
                    </Tab.Icon>
                    <Tab.Title>
                        <Text level="2">{title}</Text>
                    </Tab.Title>
                </Tab.Area>
                <Modal
                    styles={styles}
                    isModalOpen={isActive}
                    onCloseModal={toggle}
                >
                    <ParticipantsList />
                </Modal>
            </>
        )

    return null
}

export default Participants
